export const careersListSchema = {
    componentId: "CareersList",
    scalarSlots: [{ key: "paylocityId", label: "Paylocity ID", type: "text" }],
    mediaSlots: [],
};
//# sourceMappingURL=careers-list.js.map